/* ============================================================
   ElpaFix — Pushouse "Stok Bildirimi" köprüsü (ürün sayfası)
   2026-09-05

   Pushouse'un stock-notification app block'u yalnızca /products/ sayfalarında
   çalışır ve mağazada "ikon modu" açık olduğu için kendi butonu gizlidir
   (#ph_stock_notification_button_container display:none). Bu dosya:

   1) Seçili varyant tükendiyse #efp-buy-row içindeki "Sepete Ekle" / "Hızlı Al"
      butonlarını gizler, yerine "Stoğa Gelince Haber Ver" koyar. Tıklayınca
      Pushouse popup'ı açılır (#ph_stock_notification_button.click()).
      Pushouse, abone olunacak varyantı temanin sepet formundaki [name=id]
      değerinden okur — yani seçili varyanta kaydeder.
   2) URL'de ?stok=1 veya ?notify=1 varsa (koleksiyon / arama / öneri kartlarından
      gelen tıklamalar) popup'ı otomatik açar.
   3) window.efPushouseOpen() — tema içinden başka yerlerden çağrılabilir.
   ============================================================ */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var handle = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
  if (!handle) return;

  var product = null;
  var notifyBtn = null;
  var soldBtn = null;

  function phButton() { return document.getElementById('ph_stock_notification_button'); }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function selectedVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var c = forms[i].querySelector('input[name="id"]:checked');
      if (c && c.value) return String(c.value);
    }
    for (var j = 0; j < forms.length; j++) {
      var s = forms[j].querySelector('select[name="id"], input[name="id"]');
      if (s && s.value) return String(s.value);
    }
    try { var u = new URLSearchParams(location.search).get('variant'); if (u) return String(u); } catch (e) {}
    return null;
  }

  function currentVariant() {
    if (!product || !product.variants) return null;
    var id = selectedVariantId();
    var v = null;
    if (id) { for (var i = 0; i < product.variants.length; i++) { if (String(product.variants[i].id) === id) { v = product.variants[i]; break; } } }
    if (!v && product.variants.length === 1) v = product.variants[0];
    return v;
  }

  function labelFor(v) {
    var t = product ? (product.title || '') : '';
    if (v && v.title && v.title !== 'Default Title') t += ' · ' + v.title;
    return t;
  }

  function openPushouse() {
    var b = phButton();
    if (!b) return false;
    b.click();
    var v = currentVariant();
    var sel = document.querySelector('.ph-stock-notification__selected-size');
    if (sel) sel.innerHTML = '<span class="size-badge">' + esc(labelFor(v)) + '</span>';
    return true;
  }
  window.efPushouseOpen = openPushouse;

  var BELL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" width="18" height="18" aria-hidden="true" style="flex-shrink:0"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.73 21a2 2 0 01-3.46 0" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function mkBtn(cls, html, style) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'efp__btn ' + cls;
    b.innerHTML = html;
    b.setAttribute('style', style);
    return b;
  }

  function ensureButtons(row) {
    if (!notifyBtn || !notifyBtn.isConnected) {
      notifyBtn = mkBtn('efp__btn--notify js-efp-notify', BELL + '<span>Stoğa Gelince Haber Ver</span>',
        'display:none;width:100%;flex:1 1 100%;min-height:52px;border:none;border-radius:12px;background:#111827;color:#fff;font-weight:700;font-size:15px;align-items:center;justify-content:center;gap:10px;cursor:pointer;');
      notifyBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!openPushouse()) { notifyBtn.style.display = 'none'; if (soldBtn) soldBtn.style.display = 'flex'; }
      });
      row.appendChild(notifyBtn);
    }
    if (!soldBtn || !soldBtn.isConnected) {
      soldBtn = mkBtn('efp__btn--soldout', '<span>Tükendi</span>',
        'display:none;width:100%;flex:1 1 100%;min-height:52px;border:1px solid #e5e7eb;border-radius:12px;background:#f3f4f6;color:#9ca3af;font-weight:700;font-size:15px;align-items:center;justify-content:center;cursor:not-allowed;');
      soldBtn.disabled = true;
      row.appendChild(soldBtn);
    }
  }

  function applyState() {
    var row = document.getElementById('efp-buy-row');
    if (!row || !product) return;
    ensureButtons(row);
    var v = currentVariant();
    var oos = v ? !v.available : false;
    var cart = row.querySelector('.efp__btn--cart');
    var buy = row.querySelector('.efp__btn--buy');
    if (oos) {
      if (cart) cart.style.display = 'none';
      if (buy) buy.style.display = 'none';
      if (phButton()) { notifyBtn.style.display = 'flex'; soldBtn.style.display = 'none'; }
      else { notifyBtn.style.display = 'none'; soldBtn.style.display = 'flex'; }
      row.classList.add('is-oos');
    } else {
      if (cart) cart.style.display = '';
      if (buy) buy.style.display = '';
      notifyBtn.style.display = 'none';
      soldBtn.style.display = 'none';
      row.classList.remove('is-oos');
    }
  }

  function autoOpen() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    if (q.get('stok') !== '1' && q.get('notify') !== '1') return;
    var tries = 0;
    (function wait() {
      if (phButton()) { setTimeout(openPushouse, 300); return; }
      if (++tries < 40) setTimeout(wait, 250);
    })();
    try {
      q.delete('stok'); q.delete('notify');
      var qs = q.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
    } catch (e) {}
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'products/' + handle + '.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p) return;
      product = p;
      applyState();
      setInterval(applyState, 400);
      autoOpen();
    })
    .catch(function () {});
})();
